/**
 * Fetches Livestory content based on content type and ID.
 *
 * This composable retrieves content from the Livestory API using the specified
 * content type, content ID, and current language.
 *
 * @param {string} contentType - The type of content to fetch
 * @param {string} contentId - The unique identifier for the specific content
 * @returns {Promise<FetchResult>} A promise resolving to the fetched Livestory content
 *
 * @example
 * const { data } = await useLivestory('article', '12345')
 * console.log(data.value) // Displays the Livestory content
 */
export async function useLivestory(contentType: string, contentId: string) {
  const { language } = useRouteHelper()

  const query = {
    contentType: contentType,
    contentId: contentId,
    lang: language,
  }
  return await useFetch('/api/livestory', {
    query,
  })
}
